import { Paper, Skeleton } from '@mui/material';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../../../components/Button/Button.tsx';
import { Footer } from '../../../components/Footer/Footer.tsx';
import { Header } from '../../../components/Header/Header.tsx';
import Hero from '../../../components/Hero/Hero.tsx';
import { GameTest } from '../../Game/components/GameTest.tsx';
import { useLesson } from './hooks/useLesson.ts';
import './SingleLesson.scss';

const SingleLesson = () => {
	const { titleId } = useParams();
	const navigate = useNavigate();
	const { lesson, isLoading, isInstructor, deleteLesson, refetchLesson } = useLesson(titleId);
	const [testId, setTestId] = useState('');
	const container = useRef(null);
	const nextHomeworkTestId = useMemo(() => {
		refetchLesson();
		if (!testId || !lesson?.homework?.length) return undefined;

		const currentHomeworkIndex = lesson.homework.findIndex((homework) => homework.id === testId);
		if (currentHomeworkIndex === -1) return undefined;

		return lesson.homework[currentHomeworkIndex + 1]?.id;
	}, [lesson?.homework, testId]);

	const scrollToContainer = () => {
		container.current?.scrollIntoView({ behavior: 'smooth' });
	};

	useEffect(() => {
		scrollToContainer();
	}, [testId]);

	const editLesson = () => {
		navigate(`/lekcje/edytuj/${titleId}`);
	};

	const handleNextHomeworkTest = () => {
		if (!nextHomeworkTestId) return;

		setTestId(nextHomeworkTestId);
	};

	return (
		<div className="lessons light singleLesson">
			<div className="content">
				<Header light={true} />
				<Hero title={lesson?.title} />

				<div className="singleLesson__container container">
					<div className="row justify--center">
						<Button
							variant="ghost-black"
							className="lessons__edit"
							onClick={() => navigate('/nauka')}
							text="Wróć do listy"
						/>
						{isInstructor && <Button className="lessons__edit" onClick={editLesson} text="Edytuj" />}
						{isInstructor && (
							<Button variant="red" className="lessons__edit" onClick={deleteLesson} text="Usuń" />
						)}
					</div>

					<Paper className="lessons__paper paper">
						<div className="singleLesson__wrapper">
							<p className="allTests__tag">{isLoading ? <Skeleton width={100} /> : lesson?.tags[0]}</p>
							{isLoading ? (
								<Skeleton height={100} />
							) : (
								<div
									className="lessons__content"
									dangerouslySetInnerHTML={{ __html: lesson?.content }}
								/>
							)}
						</div>
					</Paper>
					<div className="singleLesson__testList">
						{!!lesson?.homework?.length && <h3 className="singleLesson__title">Testy do wykonania:</h3>}
						{lesson?.homework?.map((homework, index) => (
							<button
								key={homework.id}
								className={`singleLesson__button singleLesson__button--${homework?.myHighestResult} singleLesson__button--${homework.id === testId ? 'active' : 'inactive'}`}
								onClick={() => {
									setTestId(homework.id);
								}}
							>
								Test #{index + 1}
							</button>
						))}
					</div>
					{testId && (
						<Paper className="lessons__paper lessons__paper--game paper" ref={container}>
							<GameTest
								id={testId}
								forLesson={true}
								scrollToBottom={scrollToContainer}
								nextTest={nextHomeworkTestId ? handleNextHomeworkTest : undefined}
							/>
						</Paper>
					)}
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default SingleLesson;
